import { Badge } from 'antd';
import { FC } from 'react';
import { BadgeProps } from 'antd/lib/badge';

export const ILSBadge: FC<BadgeProps> = (props) => {
  return <Badge color={'#4c91ff'} {...props} />;
};
